import React from 'react';

import { FormControlLabel, Switch, SwitchProps } from '@mui/material';

import { camelCaseToUserText } from '@luxon/utils';

import { useFormV2Context } from './Form.context';

interface IFormSwitchInputProps<T> extends Omit<SwitchProps, 'name' | 'disabled' | 'checked' | 'onChange'> {
    label?: string;
    name: keyof T;
    disabled?: boolean;
}
export function FormSwitchInput<T>(props: IFormSwitchInputProps<T>) {
    const {
        label,
        name,
        disabled,
        ...baseInputProps
    } = props;

    const {
        formData,
        handleFormChange,
        disabled: formDisabled,
        formErrors
    } = useFormV2Context<T>();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.checked;
        handleFormChange(name, newValue);
    };

    return (
      <FormControlLabel
        label={label ?? camelCaseToUserText(String(name))}
        sx={{
          marginRight: '0px',
          color: formErrors[name] ? 'var(--color-error)' : disabled || formDisabled ? 'var(--color-text-disabled)' : ''
        }}
        disabled={disabled || formDisabled}
        control={
          <Switch
            {...baseInputProps}
            onChange={handleInputChange}
            checked={(formData[name] as boolean) ?? false}
            disabled={disabled || formDisabled}
            color={formErrors[name] ? 'error' : baseInputProps.color}
            name={String(name)} />
        }
      />
    )
};